/**
 * Mapeamento descrição do item/custo -> conta contábil correta (parametrização).
 * Fonte: planilha de mapeamento contábil - coluna "Conta Contábil".
 * Usado para exibição consistente no Resumo Detalhado e no Modal de Detalhes do Colaborador.
 */
const DESCRIPTION_TO_ACCOUNT_CODE: Record<string, string> = {
  // Salários / Proventos
  Comissões: '64109302',
  Gratificações: '64109304',
  'Horas extras': '64109307',
  'Horas Extras': '64109307',
  'Ajuda de custos': '64109308',
  Pensões: '64109313',
  'Salários e ordenados': '64109301',
  'Insalubridade / Periculosidade': '64109318',
  Férias: '64109305',
  '13º salário': '64109306',
  INSS: '64509331',
  FGTS: '64509332',
  'Abono férias const': '64109312',
  'Cestas Básicas': '64109342',
  'Desconto Cesta Básica': '64109342',
  'Seguro de vida': '64109355',
  'Vale transporte': '64109371',
  'Auxílio creche': '64109382',
  'Vale Refeição': '64109344',
  'Desconto VR': '64109344',
  'Bolsa de Ensino': '64109384',
  'Campanha Incentivo': '64109387',
  'Assistência Médica': '64109351',
  'Desconto Assistência Médica': '64109351',
  'Convênio Odonto': '64109352',
  'Desconto Odonto': '64109352',
  Indenizações: '64109309',
  'Aviso prévio programado': '64109310',
  'FGTS Art 22': '64509333',
  '1/3 Férias': '64109312',
  'Assistência Médica Sindical': '64109358',
  Teleterapia: '64109386',
  'Treinamento de Pessoal': '62869683',
  'Pessoa Física (Temporários)': '62119401',
  'Pessoa Jurídica (Temporários)': '62119402',
  'Exames Médicos': '64109356',
  'Exames Complementares': '64109360',
  'Exames Admissionais': '64109357',
  Estagiários: '64109314',
  'Taxas Sindicais': '63109523',
  'Transporte Colaboradores': '64109372',
  'Stock Option': '64100613',
  'Despesas Seguro Judicial': '62708606',
  'Transf. Gest. Abat.': '6289511',
  'Transferência Interna de Custos': '62869501',
  'Participação Lucros': '69109303'
}

/**
 * Remove zeros à esquerda do código da conta contábil para exibição.
 * Ex: "0064109302" -> "64109302"
 */
export function formatAccountCodeForDisplay(accountCode: string | null | undefined): string {
  if (accountCode == null || accountCode === '') return '-'
  const trimmed = String(accountCode).trim()
  if (trimmed === '') return '-'
  const withoutLeadingZeros = trimmed.replace(/^0+/, '') || '0'
  return withoutLeadingZeros
}

/**
 * Retorna a conta contábil para exibição: prioriza o mapeamento por descrição (parametrização),
 * senão usa o código do backend normalizado (sem zeros à esquerda).
 */
export function getAccountCodeForDisplay(
  description: string,
  backendAccountCode?: string | null
): string {
  const normalizedName = description?.trim() ?? ''
  const mapped = DESCRIPTION_TO_ACCOUNT_CODE[normalizedName]
  if (mapped != null) return mapped
  return formatAccountCodeForDisplay(backendAccountCode)
}
